
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/first-litter",
      function () {
        return require("private-next-pages/first-litter/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/first-litter"])
      });
    }
  